'use strict';

/* globals RELATIVE_PATH, $ */

require([
	RELATIVE_PATH + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
], function (Vue) {
	Vue.component('course-chapters', {
		props: ['initData', 'openChapter', 'currentChapter'],
		data: function () {
			return {
				chapters: this.initData.chapters,
			};
		},
		mounted: function () {

		},
		methods: {
			toggleChapterDescripton: function (index, chapter) {
				$('#chapter' + index).collapse('toggle');

				chapter.isCollapsed = !chapter.isCollapsed;
			},
		},
		template:
		'<ul class="chapters-list">' +
			'<li v-for="(chapter, index) in chapters" :class="[currentChapter === index ? \'current-chapter\' : \'\']">' +
				'<button class="chapter-title" v-on:click="openChapter(index)">{{chapter.title}}</button>' +
				'<button class="chapter-expand" v-on:click="toggleChapterDescripton(index, chapter)"><i :class="[chapter.isCollapsed ? \'fa-arrow-up\' : \'fa-arrow-down\', \'fa\']"></i></button>' +
				'<div v-on:click="openChapter(index)" :id="\'chapter\' + index" aria-expanded="false" class="collapse">' +
					'<p class="chapter-description" v-html="chapter.description"></p>' +
				'</div>' +
			'</li>' +
		'</ul>',
	});
});
